import EventEmitter from 'events';
import { isMobile } from '../../utils';
import Video, { LocalDataTrack } from 'twilio-video';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Logger, saveTwilioLogs } from '../../utils';
import { useTwilioAppState } from '../../state';

const OurEventListener = new EventEmitter();
OurEventListener.on('event', function (event) {
    //console.log('The SDK raised an event:', event);
    window.lastTwilio = Date.now();
});
OurEventListener.on('message', function (event) {
    //console.log('The SDK raised an event:', event);
    window.lastTwilio = Date.now();
});
OurEventListener.on('networkQualityLevelChanged', function (event) {
    //console.log('The SDK raised an event:', event);
    window.lastTwilio = Date.now();
});
//OurEventListener.on('message', function (event) {
//    //console.log('The SDK raised an event:', event);
//    window.lastTwilio = Date.now();
//});
//OurEventListener.on('message', function (event) {
//    //console.log('The SDK raised an event:', event);
//    window.lastTwilio = Date.now();
//});


// @ts-ignore
window.TwilioVideo = Video;

export default function useRoom(localTracks, onError, options) {
    const [room, setRoom] = useState(new EventEmitter());
    const [isConnecting, setIsConnecting] = useState(false);
    const [isPublishingTracks, setIsPublishingTracks] = useState(false);
    const localTracksRef = useRef([]);
    const optionsRef = useRef(options);
    const { _isMounted, settings, twilioSettings } = useTwilioAppState();
    let enableTwilioDebugConsoleLogs = null, storeTwilioLogsByLevel = null;
    if (twilioSettings && twilioSettings.settings) {  // TwilioSettings is provided either by API (twilioSettings.isDynamicSettings = true) or by Text Area(twilioSettings.isDynamicSettings = false)
        enableTwilioDebugConsoleLogs = twilioSettings.isDynamicSettings ? twilioSettings.settings.enableDebugConsoleLogs : twilioSettings.settings.enabledebugconsolelogs;
        storeTwilioLogsByLevel = twilioSettings.isDynamicSettings ? twilioSettings.settings.kustoLogLevel : twilioSettings.settings.kustologlevel;
    }  
    else { // Reading from serverData config
        enableTwilioDebugConsoleLogs = window && window.serverData && window.serverData.data ? window.serverData.data.enableTwilioDebugConsoleLogs : false;
        storeTwilioLogsByLevel = window && window.serverData && window.serverData.data ? window.serverData.data.storeTwilioLogsByLevel : "off";
    }    

    useEffect(() => {
        // This allows the connect function to always access the most recent version of the options object. This allows us to
        // reliably use the connect function at any time.
        optionsRef.current = options;
    }, [options]);

    useEffect(() => {
        // It can take a moment for Video.connect to connect to a room. During this time, the user may have enabled or disabled their
        // local audio or video tracks. If this happens, we store the localTracks in this ref, so that they are correctly published
        // once the user is connected to the room.
        // localTracksRef.current = localTracks;
        window.localTracks = localTracks;
    }, [localTracks]);    

    const connect = useCallback((token, roomName, tracks) => {
        setIsConnecting(true);
        //const connectRoomPromise = new Promise((resolve, reject) => {                      
        console.log({ connectionOptions: optionsRef.current });
        if (Video && Video.Logger) {
            const twilioLogger = Video.Logger.getLogger('twilio-video');
            const originalFactory = twilioLogger.methodFactory;
            twilioLogger.methodFactory = function (methodName, logLevel, loggerName) {
                const method = originalFactory(methodName, logLevel, loggerName);
                return function (datetime, logLevel, component, message, data) {
                    if (enableTwilioDebugConsoleLogs) {
                        method(datetime, logLevel, component, message, data); // this will log to console    
                    }
                    saveTwilioLogs(arguments, storeTwilioLogsByLevel, roomName); // this can log to our own server.
                };
            };

            twilioLogger.setLevel(twilioSettings && twilioSettings.settings ? twilioSettings.settings.logLevel : settings.logLevel);
        }

        let settingsOptions = { ...optionsRef.current };

        let twilioDynamicSettingsRemoveFromConnection = window && window.serverData && window.serverData.data && window.serverData.data.twilioDynamicSettingsRemoveFromConnection ? window.serverData.data.twilioDynamicSettingsRemoveFromConnection : "";

        try {
            if (settingsOptions && twilioDynamicSettingsRemoveFromConnection) {
                let removeSettingsKeys = twilioDynamicSettingsRemoveFromConnection.split(',');
                removeSettingsKeys.forEach((rKey) => {
                    for (const key in settingsOptions) {
                        if (rKey && key && key.toLowerCase().indexOf(rKey.toLowerCase()) > -1) {
                            delete settingsOptions[key]; // Needs to be deleted from settings
                        }
                    }
                });
            }
        } catch (err) {
        }

        let connectOptions = tracks ?
            {
                ...settingsOptions,
                name: roomName,
                tracks: [...tracks, new LocalDataTrack()],
                eventListener: OurEventListener
            } :
            {
                ...settingsOptions,
                name: roomName,
                eventListener: OurEventListener
            };
       
        return Video.connect(token, connectOptions).then(
                newRoom => {
                    setRoom(newRoom);
                    Logger("UI.Twilio.Room.Connect", new Date(), {
                        "room": newRoom,
                        "options": settingsOptions ? settingsOptions : null
                    }, roomName);
                    const disconnect = () => newRoom.disconnect();
                    // This app can add up to 13 'participantDisconnected' listeners to the room object, which can trigger
                    // a warning from the EventEmitter object. Here we increase the max listeners to suppress the warning.
                    newRoom.setMaxListeners(24);
                    newRoom.once('disconnected', (room, error) => {
                        if (error) {
                            Logger("UI.Twilio.Room.Disconnect.Error", new Date(), {
                                "room": room,
                                "error": error
                            }, roomName);
                        }

                        // Reset the room only after all other `disconnected` listeners have been called.
                        //setTimeout(() => setRoom(new EventEmitter()));
                        window.removeEventListener('beforeunload', disconnect);
                        if (isMobile) {
                            window.removeEventListener('pagehide', disconnect);
                        }
                        window.twilioRoom = null;
                    });

                    window.twilioRoom = newRoom;
                    newRoom.localParticipant.videoTracks.forEach(publication =>
                        // All video tracks are published with 'low' priority because the video track
                        // that is displayed in the 'MainParticipant' component will have it's priority
                        // set to 'high' via track.setPriority()
                        publication.setPriority('low')
                    );                   
                    if (_isMounted && _isMounted.current === true)
                        setIsConnecting(false);

                    // Add a listener to disconnect from the room when a user closes their browser
                    window.addEventListener('beforeunload', disconnect);

                    if (isMobile) {
                        // Add a listener to disconnect from the room when a mobile user closes their browser
                        window.addEventListener('pagehide', disconnect);
                    }
                     return { room: newRoom, isSuccess: true, error: null };
                },
                error => {                    
                    onError(error);
                    if (_isMounted && _isMounted.current === true)
                        setIsConnecting(false);
                    const activityCode = error && error.code && (error.code === 53001 || error.code === 53405) ? "UI.Twilio.Room.Connect.Reconnecting" : "UI.Twilio.Room.Connect.Error";
                    Logger(activityCode, new Date(), { "error": error }, roomName);
                    console.log(error);
                    return { room: null, isSuccess: false, error };
                }); 
    },
    [onError]);
   
    return { room, isConnecting, connect };
}

